<template>
  <div>
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="tab-text">
          <div class="vx-row">
            <div class="vx-col md:w-1/3 w-full mt-2">
              <vs-input
                v-validate="'required|min:3'"
                data-vv-validate-on="blur"
                type="account"
                name="fullName"
                :label="$t('adminUser.fullName')"
                v-model="user.fullName"
                autocomplete="off"
                class="w-full"/>
              <span class="text-danger text-sm">{{
                errors.first("fullName")
              }}</span>
            </div>
            <div class="vx-col md:w-1/3 w-full mt-2">
              <vs-input
                v-validate="'required|min:3'"
                data-vv-validate-on="blur"
                type="text"
                name="organizationName"
                :label="$t('adminUser.organizationName')"
                v-model="user.organizationName"
                autocomplete="off"
                class="w-full"/>
              <span class="text-danger text-sm">{{
                errors.first("organizationName")
              }}</span>
            </div>
            <div class="vx-col md:w-1/3 w-full mt-2">
              <vs-input
                v-validate="'required|email'"
                data-vv-validate-on="blur"
                type="email"
                name="email"
                label="Email"
                v-model="user.email"
                autocomplete="off"
                class="w-full"/>
              <span class="text-danger text-sm">{{
                errors.first("email")
              }}</span>
            </div>
          </div>
          <div class="vx-row">

            <div class="vx-col md:w-1/3 w-full mt-2">
              <vs-input
                v-validate="'required|numeric|min:10|max:11'"
                data-vv-validate-on="blur"
                type="text"
                name="phoneNumber"
                :label="$t('adminUser.phoneNumber')"
                v-model="user.phoneNumber"
                autocomplete="off"
                class="w-full"/>
              <span class="text-danger text-sm">{{
                errors.first("phoneNumber")
              }}</span>
            </div>
            <div class="vx-col md:w-1/3 w-full mt-2">
              <label class="vs-input--label">{{$t('adminUser.gender')}}</label>
              <v-select
                class=""
                v-model="genderModel"
                :clearable="false"
                :options="genderOptions"
                data-vv-validate-on="input"
                v-validate="'required'"
                name="gender"/>
              <span class="text-danger text-sm">{{
                errors.first("gender")
              }}</span>
            </div>
            <div class="vx-col md:w-1/3 w-full mt-2">
              <label class="vs-input--label">{{$t('adminUser.birthday')}}</label>
              <datepicker :format="'dd/MM/yyyy'" v-model="user.birthday"
                          data-vv-validate-on="input" v-validate="''" name="birthday"></datepicker>
              <span class="text-danger text-sm">{{ errors.first('birthday') }}</span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/3 w-full mt-2">
              <label class="vs-input--label">{{$t('adminUser.operationStatus')}}</label>
              <v-select
                v-model="activeStatusModel"
                :clearable="false"
                :options="activeStatusOptions"
                data-vv-validate-on="input"
                v-validate="'required'"
                name="activeStatus"/>
              <span class="text-danger text-sm">{{
                errors.first("activeStatus")
              }}</span>
            </div>
            <div class="vx-col md:w-1/3 w-full mt-2">
              <vs-input
                v-validate="isUpdate ? { is: user.rePassword, min:6 } : {required: true, is: user.rePassword, min: 6}"
                data-vv-validate-on="blur"
                type="password"
                name="password"
                :label="$t('adminUser.password')"
                v-model="user.password"
                autocomplete="off"
                class="w-full"/>
              <span class="text-danger text-sm">{{
                errors.first("password")
              }}</span>
            </div>
            <div class="vx-col md:w-1/3 w-full mt-2">
              <vs-input
                v-validate="isUpdate ? { is: user.rePassword, min:6 } : {required: true, is: user.rePassword, min: 6}"
                data-vv-validate-on="blur"
                type="password"
                name="rePassword"
                :label="$t('adminUser.confirmPassword')"
                v-model="user.rePassword"
                autocomplete="off"
                class="w-full"/>
              <span class="text-danger text-sm">{{
                errors.first("rePassword")
              }}</span>
            </div>
          </div>
          <div class="vx-row">

          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/4 w-full mt-2">
              <label class="vs-input--label">{{$t('adminUser.city')}}</label>
              <v-select
                height="140px"
                :dense="true"
                v-model="province"
                :clearable="false"
                :options="cityOptions"
                data-vv-validate-on="input"
                v-validate="''"
                name="city"
              />
              <span class="text-danger text-sm">{{
                errors.first("city")
              }}</span>
            </div>
            <div class="vx-col md:w-1/4 w-full mt-2">
              <label class="vs-input--label">{{$t('adminUser.district')}}</label>
              <v-select
                class=""
                v-model="district"
                :clearable="false"
                :options="districtOptions"
                data-vv-validate-on="blur"
                v-validate="''"
                name="district">
                <span slot="no-options">
                 {{$t('adminUser.spanNoOption')}}
                </span>
                </v-select>
              <span class="text-danger text-sm">{{
                errors.first("district")
              }}</span>
            </div>
            <div class="vx-col md:w-1/4 w-full mt-2">
              <label class="vs-input--label">{{$t('adminUser.subDistrict')}}</label>
              <v-select
                class=""
                v-model="subDistrict"
                :clearable="false"
                :options="subDistrictOptions"
                data-vv-validate-on="blur"
                v-validate="''"
                name="subDistrict"
              />
              <span class="text-danger text-sm">{{
                errors.first("subDistrict")
              }}</span>
            </div>
            <div class="vx-col md:w-1/4 w-full mt-2">
              <vs-input
                class="w-full"
                :label="$t('adminUser.houseNumber')"
                v-model="user.houseNumber"
                v-validate="''"
                name="houseNumber"/>
              <span class="text-danger text-sm">{{
                errors.first("houseNumber")
              }}</span>
            </div>
          </div>

          <div class="vx-row">

          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-2">
              <vs-input
                class="w-full"
                :label="$t('adminUser.address')"
                v-model="fullAddressModel"
                v-validate="''"
                name="full_address"
                readonly="true"/>
            </div>

            <div class="vx-col md:w-1/2 w-full mt-2">
              <label class="vs-input--label">{{$t('adminUser.classify')}}</label>
              <v-select
                class=""
                v-model="selectedManager"
                :clearable="false"
                :options="optionManager"
                data-vv-validate-on="blur"
                v-validate="''"
                >
                </v-select>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm">{{`${isUpdate ?
                  $t('adminUser.updateUser'): $t('adminUser.createUser') }`}}
                </vs-button>
                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">{{$t('adminUser.back')}}
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>

</template>
<script>

  import vSelect from 'vue-select'
  import province from '@/assets/utils/province.js';
  import Datepicker from '@/components/datepicker/Datepicker.vue';
  export default {
    data() {
      return {
        optionManager:[
          {value: 0, label: 'Unknown'},
          {value: 1, label: 'InfoCare'},
          {value: 2, label: 'SMCC'}
        ],
        isUpdate: false,
        id: null,
        registerSuccess: 0,
        genderOptions: [
          {value: 0, label: 'Khác'},
          {value: 1, label: 'Nữ'},
          {value: 2, label: 'Nam'}
        ],
        activeStatusOptions: [
          {value: 0, label: 'Chưa kích hoạt'},
          {value: 1, label: 'Hoạt động'},
          {value: 2, label: 'Bị khóa'}
        ],
        cityOptions: province.getProvince(),
        districtOptions: province.getDistrict(),
        subDistrictOptions: province.getSubDistrict(),
        user: {
          gender: null,
          city: null,
          district: null,
          subDistrict: null,
          address: null,
          houseNumber: null,
          password: "",
          rePassword: "",
          activeStatus: 0,
          customerType:null
        },
      };
    },
    components: {
      vSelect,
      Datepicker
    },
    computed: {
      validateForm() {
        return !this.errors.any();
      },
      genderModel: {
        get() {
          let obj = this.genderOptions.find(x => x.value === this.user.gender);
          if (!obj) {
            return null;
          }
          return {
            label: obj.label,
            value: this.user.gender
          }
        },
        set(obj) {
          this.user.gender = obj.value;
        }
      },
      activeStatusModel: {
        get() {
          let obj = this.activeStatusOptions.find(x => x.value === this.user.activeStatus);
          if (!obj) {
            return null;
          }
          return {
            label: obj.label,
            value: this.user.activeStatus
          }
        },
        set(obj) {
          this.user.activeStatus = obj.value;
        }
      },
      province: {
        get() {
          let obj = this.cityOptions.find(x => x.value === this.user.city);
          if (!obj) {
            return null;
          }
          return {
            label: obj.label,
            value: this.user.city
          }
        },
        set(obj) {
          this.user.city = obj.value;
          this.districtOptions = province.getDistrict(obj.value);
          this.user.district = this.districtOptions[0].value;
          this.subDistrictOptions = province.getSubDistrict(this.user.city, this.user.district);
          this.user.subDistrict = this.subDistrictOptions[0].value;
        }
      },
      district: {
        get() {
          let obj = this.districtOptions.find(x => x.value === this.user.district);
          if (!obj) {
            return null;
          }
          return {
            label: obj.label,
            value: this.user.district
          }
        },
        set(obj) {
          this.user.district = obj.value;
          this.subDistrictOptions = province.getSubDistrict(this.user.city, obj.value);
          this.user.subDistrict = this.subDistrictOptions[0].value;
        }
      },
      selectedManager: {
        get(){
          let object = this.optionManager.find(item => item.value === this.user.customerType);
          if (!object) return null;
          return {
            label: object.label,
            value: this.user.customerType
          }
        },
        set(object){
          this.user.customerType = object.value
        }
      },
      subDistrict: {
        get() {
          let obj = this.subDistrictOptions.find(x => x.value === this.user.subDistrict);
          if (!obj) {
            return null;
          }
          return {
            label: obj.label,
            value: this.user.subDistrict
          }
        },
        set(obj) {
          this.user.subDistrict = obj.value
        }
      },
      fullAddressModel: {
        get() {
          let houseNumber = `${this.user.houseNumber ? this.user.houseNumber + ', ' : ''}`
          let subDistrict = `${this.subDistrict && this.subDistrict.label ? this.subDistrict.label + ', ' : ''}`
          let district = `${this.district && this.district.label ? this.district.label + ", " : ''}`
          let province = `${this.province && this.province.label ? this.province.label: ''}`;
          /* eslint-disable */
          this.user.fullAddress = houseNumber + subDistrict + district + province;
          return this.user.fullAddress;
        },
      }
    },
    created() {
      this.userId = this.$route.query.id;
      if (this.userId) {
        this.$vs.loading();
        this.$oauth.post('/user/admin/find-by-id/' + this.userId).then((response) => {
          this.$vs.loading.close();
          this.districtOptions = province.getDistrict(response.data.city);
          this.subDistrictOptions = province.getSubDistrict(response.data.city, response.data.district);
          response.data.organizationName = response.data.organization ? response.data.organization.organizationName : "";
          this.user = response.data;
          this.isUpdate = true;
        }).catch((err) => {
          this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
      }
      this.$eventBus.$on('i18n', (event) =>{
        this.checkGender();
        this.checkStatus();
      })
      this.checkGender();
      this.checkStatus();
    },
    methods: {
      checkGender: function (){
        this.genderOptions[0].label =  this.$t('adminUser.other');
        this.genderOptions[1].label =  this.$t('adminUser.male');
        this.genderOptions[2].label =  this.$t('adminUser.female');
      },
      checkStatus: function (){
        this.activeStatusOptions[0].label =  this.$t('adminUser.notActivated');
        this.activeStatusOptions[1].label =  this.$t('adminUser.active');
        this.activeStatusOptions[2].label =  this.$t('adminUser.lock');
      },
      getLabelString(object) {
        return (object && object.label);
      },
      changeGender () {
        this.$validator.validateAll()
      },
      async saveChanges(evt) {

        evt.preventDefault();
        if (!this.validateForm) return;

        const result = await this.$validator.validateAll();
        if (!result) return;
        let path = this.isUpdate ? ('/user/admin/update/' + this.userId ) : '/user/admin/create';
        this.$vs.loading();
        this.user.organizationId = this.user.organization ? this.user.organization.id : null;
        this.$oauth.post(path, this.user).then((response) => {
          const data = response.data;
          if(!this.isUpdate){
            const payload = {
              organization: data.organization.id,
              userId: data.id
            }
            this.$business.post('user-package/active-trial-package', payload).then((res) =>{
            })
          }
          this.$vs.loading.close();
          this.$vs.notify({
              color: 'primary',
              text: `${this.isUpdate ? this.$t('adminUser.updateUser') : this.$t('adminUser.more')}` + this.$t('adminUser.accountSuccess'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
            });
          this.$router.go(-1)
        }).catch((err) => {
          this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
      },
    }
  };
</script>
